// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_i6c","cls2":"PaperPreviewList-cls2_cwK PaperPreviewList-cls1_i6c"};